export default {
  en: {
    anchor_label: 'See more',
  },
};
